export const NOTIFICATIONS_TYPES = {
  LINKED_ACCOUNT_NOT_ASSOCIATED_WITH_DIVISION: 'LINKED_ACCOUNT_NOT_ASSOCIATED_WITH_DIVISION',
  NEW_LINKED_ACCOUNT: 'NEW_LINKED_ACCOUNT',
  NOT_CONNECTED_LINKED_ACCOUNT: 'NOT_CONNECTED_LINKED_ACCOUNT',
  AZURE_APP_REGISTRATION_EXPIRES: 'AZURE_APP_REGISTRATION_EXPIRES',
  ONBOARDING_SUCCEED: 'ONBOARDING_SUCCEED',
  ONBOARDING_FAILED: 'ONBOARDING_FAILED',
};
